// Events
import { MODAL_CLOSE } from 'events';
import { component } from 'picoapp';
import Swiper, { A11y, Autoplay, Manipulation, Mousewheel, Navigation, Scrollbar } from 'swiper';

import { setCSSProperty } from 'utils/css';

// Utils
import choozy from 'utils/choozy';

Swiper.use([A11y, Autoplay, Navigation, Manipulation, Mousewheel, Scrollbar]);

export default component((node, ctx) => {
  const { slider, progressIndicator, sizeOptionsContainer } = choozy(node);

  const progressIndicators = [].concat(progressIndicator);

  const carousel = new Swiper(slider, {
    slidesPerView: 1,
  });

  carousel.on('slideChange', (data) => {
    progressIndicators.forEach((indicator) => {
      indicator.classList[
        +indicator.dataset.progressIndicator === data.activeIndex ? 'add' : 'remove'
      ]('active');
    });
  });

  progressIndicators.forEach((el) => {
    el.addEventListener('click', () => {
      carousel.slideTo(+el.dataset.slideRef);
    });
  });

  let collapsedProductOption = null;

  const toggleOptionContainer = (container) => {
    const toggle = container.querySelector('[data-options-toggle]');
    const inner = container.querySelector('[data-options-inner]');

    container.classList.toggle('active');
    setCSSProperty(container, '--inner-height', '0px');

    const isActive = container.classList.contains('active');

    toggle.addEventListener(
      'transitionend',
      () => {
        setCSSProperty(container, '--inner-height', `${inner.offsetHeight}px`);
      },
      { once: true },
    );

    if (isActive) {
      container.style.zIndex = 1;
    } else {
      container.addEventListener(
        'transitionend',
        () => {
          container.style.zIndex = 0;
        },
        { once: true },
      );
    }

    collapsedProductOption = isActive ? container : null;
  };

  node.addEventListener('click', (e) => {
    const optionsContainer = e.target.closest('[data-product-options-container]');
    const optionsToggle = e.target.closest('[data-options-toggle]');

    if (!optionsContainer && collapsedProductOption) {
      toggleOptionContainer(collapsedProductOption);
      return;
    }

    if (optionsToggle) {
      toggleOptionContainer(optionsContainer);
    }
  });

  node.addEventListener('product:form:submit', () => {
    ctx.emit(MODAL_CLOSE, null, { id: 'product_info_modal' });
  });

  node.addEventListener('product:form:variant-selected', (e) => {
    e.stopPropagation();

    if (collapsedProductOption) {
      toggleOptionContainer(collapsedProductOption);
    }
  });

  node.addEventListener('product:form:submit-error', (e) => {
    e.stopPropagation();

    toggleOptionContainer(sizeOptionsContainer);
  });
});
